import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import type { AppConfig } from './config';
import { AccountLayout } from './layout/AccountLayout';
import { MspLayout } from './layout/MspLayout';
import { TenantLayout } from './layout/TenantLayout';
import { AccountPage } from './pages/AccountPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { HomeRedirect, RequireAuth } from './pages/guards';
import { MspPortalPage } from './pages/msp/MspPortalPage';
import { TenantFormPage } from './pages/msp/TenantFormPage';
import { AdministratorsPage } from './pages/tenant/AdministratorsPage';
import { AlertProfilesPage } from './pages/tenant/AlertProfilesPage';
import { AlertsPage } from './pages/tenant/AlertsPage';
import { EventsPage } from './pages/tenant/EventsPage';
import { IntegrationsPage } from './pages/tenant/IntegrationsPage';
import { OverviewPage } from './pages/tenant/OverviewPage';
import { SensorDetailPage } from './pages/tenant/SensorDetailPage';
import { CameraDetailPage } from './pages/tenant/CameraDetailPage';
import { CamerasPage } from './pages/tenant/CamerasPage';
import { PlatesPage } from './pages/tenant/PlatesPage';
import { SensorsPage } from './pages/tenant/SensorsPage';
import { SettingsPage } from './pages/tenant/SettingsPage';
import { SitesPage } from './pages/tenant/SitesPage';

export function App({ config }: { config: AppConfig }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage mspName={config.mspName} />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/account" element={<AccountLayout mspName={config.mspName} />}>
            <Route index element={<AccountPage mspName={config.mspName} />} />
          </Route>
          <Route path="/msp" element={<MspLayout mspName={config.mspName} />}>
            <Route index element={<MspPortalPage />} />
            <Route path="tenants/new" element={<TenantFormPage />} />
          </Route>
          <Route path="/t/:tenantId" element={<TenantLayout mspName={config.mspName} />}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<OverviewPage />} />
            <Route path="sites" element={<SitesPage />} />
            <Route path="sensors" element={<SensorsPage />} />
            <Route path="sensors/:deviceId" element={<SensorDetailPage />} />
            <Route path="cameras" element={<CamerasPage />} />
            <Route path="cameras/:deviceId" element={<CameraDetailPage />} />
            <Route path="plates" element={<PlatesPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="alert-profiles" element={<AlertProfilesPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="administrators" element={<AdministratorsPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
